<svelte:options customElement={{
  tag: 'logo-block',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' },
    dark: { reflect: true, type: 'Boolean' },
    lang: { reflect: true, type: 'String' },
    alt: { reflect: true, type: 'String' },
    width: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * ロゴパーツ
   * サッポロHDロゴの各バリエーションを表示
   * @prop {string} variant - ロゴバリエーション:
   *   'default' (縦型ロゴ), 'horizontal' (横型ロゴ), 'star' (星マーク),
   *   'copy' (「乾杯をもっとおいしく。」), 'logotype' (社名ロゴタイプ),
   *   'stop' (STOP!20歳未満飲酒), 'recycle' (リサイクルマーク)
   * @prop {boolean} dark - ダークモード（白色ロゴ）: default, horizontal, logotype で有効
   * @prop {string} lang - 言語（logotype のみ）: 'jp' / 'en'
   * @prop {string} alt - alt テキスト（空の場合は自動設定）
   * @prop {string} width - 幅指定（CSS値、例: '120px', '100%'）
   */
  export let variant = 'default';
  export let dark = false;
  export let lang = 'jp';
  export let alt = '';
  export let width = '';

  const basePath = '/common/images/logo';

  const altTexts = {
    default: 'サッポロ',
    horizontal: 'サッポロ',
    star: 'サッポロ星マーク',
    copy: '乾杯をもっとおいしく。',
    logotype_jp: 'サッポロビール株式会社',
    logotype_en: 'SAPPORO BREWERIES LTD.',
    stop: 'STOP! 20歳未満飲酒',
    recycle: 'リサイクル'
  };

  $: src = getSrc(variant, dark, lang);
  $: altText = alt || getAltText(variant, lang);
  $: style = width ? `width: ${width};` : '';

  function getSrc(v, d, l) {
    switch (v) {
      case 'default':
        return d ? `${basePath}/logo_dark.svg` : `${basePath}/logo.svg`;
      case 'horizontal':
        return d ? `${basePath}/logo_h_dark.svg` : `${basePath}/logo_h.svg`;
      case 'star':
        return `${basePath}/logo_star.svg`;
      case 'copy':
        return `${basePath}/logo_copy.svg`;
      case 'logotype':
        if (l === 'en') {
          return d ? `${basePath}/logotype_en_dark.svg` : `${basePath}/logotype_en.svg`;
        }
        return d ? `${basePath}/logotype_jp_dark.svg` : `${basePath}/logotype_jp.svg`;
      case 'stop':
        return `${basePath}/logo_stop.svg`;
      case 'recycle':
        return `${basePath}/logo_recycle.png`;
      default:
        return `${basePath}/logo.svg`;
    }
  }

  function getAltText(v, l) {
    if (v === 'logotype') {
      return l === 'en' ? altTexts.logotype_en : altTexts.logotype_jp;
    }
    return altTexts[v] || altTexts.default;
  }
</script>

<span class="mod-logo" {style}>
  <img src={src} alt={altText} />
</span>
